<template>
  <DarwinDialog
    :open="open"
    v-bind="$attrs"
    @keydown:esc="$emit('cancel')"
    @click:outside="$emit('cancel')"
  >
    <DarwinDialogLayout
      :is-confirm-disabled="!isConfirmationValid"
      :kind="kind"
      @close="$emit('cancel')"
      @cancel="$emit('cancel')"
      @confirm="$emit('confirm')"
    >
      <template #title>
        <slot name="title" />
      </template>
      <template #body>
        <slot name="body" />
        <TextInput
          v-model="confirmationValue"
          auto-focus
          label="Confirmation text"
          :placeholder="targetText"
          required
          :error="confirmationError"
        />
      </template>
      <template #cancel-text>
        <slot name="cancel-text" />
      </template>
      <template #confirm-text>
        <slot name="confirm-text" />
      </template>
    </DarwinDialogLayout>
  </DarwinDialog>
</template>

<script lang="ts" setup>
import DarwinDialog from '@/uiKit/Dialog/DarwinDialog.vue'
import DarwinDialogLayout from '@/uiKit/Dialog/DarwinDialogLayout.vue'
import TextInput from '@/uiKit/TextInput/TextInput.vue'
import { computed, ref } from 'vue'
import type { DarwinKindType } from '@/uiKit/types'

const props = withDefaults(
  defineProps<{
    open: boolean
    targetText: string
    kind?: DarwinKindType
  }>(),
  {
    kind: 'primary',
  },
)

defineEmits<{
  (e: 'cancel'): void
  (e: 'confirm'): void
}>()

const confirmationValue = ref('')

const isConfirmationValid = computed(() => confirmationValue.value === props.targetText)

const confirmationError = computed(() =>
  isConfirmationValid.value ? undefined : `Please type exactly the following: ${props.targetText}`,
)
</script>
